import React, { useState } from 'react';
import { BringzzPageContainer, BringzzText, BringzzIcon, BringzzInput, BringzzDate, BringzzButton, BringzzAccordion, BringzzBottomDrawer, BringzzRadioList, BringzzRadio } from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { Mode } from "@bringzz/components";

let state = {
    checked: (
        <BringzzIcon
            icon="IconCheck"
            library="Custom"
            className="h-5 w-5 p-1 bg-magic-lilac text-light rounded-full"
            size="12"
        />
    ),
    unChecked: (
        <div></div>
    ),
};

const PrescriptionFormProductsPage = () => {
    const { navigate } = useNavigation();

    // Form state
    const [productName, setProductName] = useState('');
    const [manufacturer, setManufacturer] = useState('');
    const [manufacturerDrawerOpened, setManufacturerDrawerOpened] = useState(false);
    const [applicationForm, setApplicationForm] = useState('');
    const [applicationFormDrawerOpened, setApplicationFormDrawerOpened] = useState(false);
    const [dosage, setDosage] = useState('');
    const [dosageDrawerOpened, setDosageDrawerOpened] = useState(false);
    const [packSize, setPackSize] = useState('');
    const [packSizeDrawerOpened, setPackSizeDrawerOpened] = useState(false);
    const [opAmount, setOpAmount] = useState(1);

    const manufacturers = [
        "Pfizer",
        "Novartis",
        "Roche",
        "Merck",
        "GlaxoSmithKline",
        "Johnson & Johnson",
        "AstraZeneca",
        "Sanofi",
        "Bristol Myers Squibb",
        "Abbott Laboratories"
    ];

    const dosageOptions = [
        "5mg",
        "10mg",
        "20mg",
        "25mg",
        "50mg",
        "75mg",
        "100mg",
        "150mg",
        "200mg",
        "500mg"
    ];

    const packSizeOptions = [
        "10 units",
        "20 units",
        "30 units",
        "50 units",
        "60 units",
        "90 units",
        "100 units",
        "120 units",
        "180 units"
    ];

    const medicamentForms = [
        "Tablet",
        "Capsule",
        "Syrup",
        "Injection",
        "Cream/Ointment",
        "Suppository"
    ];

    const validateForm = () => {
        return Boolean(
            productName.trim() &&
            manufacturer.trim() &&
            applicationForm &&
            dosage.trim() &&
            packSize.trim() &&
            opAmount > 0
        );
    };

    return (
        <BringzzPageContainer
            className="bg-white pb-24"
            header={{
                left: <BringzzIcon
                    icon="IconClose"
                    folder="LineIcons"
                    size="16"
                    className="cursor-pointer"
                    onClick={() => navigate('/basket')}
                />,
            }}
            footer={
                <div className='p-4 space-x-2 flex'>
                    <BringzzButton
                        size='lg'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        onClick={() => {
                            navigate('/basket');
                        }}
                        disabled={!validateForm()}
                    >
                        Continue
                    </BringzzButton>
                    <BringzzButton
                        size='lg'
                        className='bg-white w-full flex justify-center border border-gray-300'
                        onClick={() => navigate('/basket')}
                    >
                        Cancel
                    </BringzzButton>
                </div>
            }
        >
            <div className='p-4 space-y-6'>
                <div className='space-y-4'>
                    <BringzzText tag="h1" className="text-center">Please check your prescribed products</BringzzText>
                    <BringzzText tag="h4" className="text-center text-gray-500 font-thin">Please enter the following fields manually so that we can fully read your prescription</BringzzText>
                </div>

                <div className='space-y-4'>
                    <BringzzInput
                        label="Product Name"
                        placeholder="Enter Product Name"
                        tooltip="Name of the prescribed medication"
                        onChange={(e) => setProductName(e.target.value)}
                    />

                    <BringzzInput
                        label="Manufacturer"
                        placeholder={manufacturer || "Select Manufacturer"}
                        tooltip="Name of the medication manufacturer"
                        readOnly={true}
                        className="cursor-pointer"
                        icon={{
                            right: <BringzzIcon
                                icon="IconChevronDown"
                                library="Custom"
                                className="h-5 w-5 p-1 text-midnight-blue rounded-full"
                                size="12"
                            />
                        }}
                        onClick={() => setManufacturerDrawerOpened(true)}
                    />

                    <BringzzBottomDrawer
                        isOpen={manufacturerDrawerOpened}
                        close={() => setManufacturerDrawerOpened(false)}
                        title='Select Manufacturer'
                    >
                        <div className='px-4 py-6'>
                            <BringzzRadioList
                                onChange={(newValue) => {
                                    setManufacturer(newValue);
                                }}
                                state={state}
                                className="rounded-xl w-full text-center"
                            >
                                {manufacturers.map((name) => (
                                    <BringzzRadio
                                        key={name}
                                        value={name}
                                        className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400"
                                    >
                                        <div>{name}</div>
                                    </BringzzRadio>
                                ))}
                            </BringzzRadioList>
                        </div>

                        <div className='text-center mb-12 px-4'>
                            <BringzzButton
                                className='bg-magic-lilac w-full flex justify-center'
                                onClick={() => setManufacturerDrawerOpened(false)}
                            >
                                Confirm
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>

                    <BringzzInput
                        label="Application Form"
                        placeholder={applicationForm || "Select Application Form"}
                        tooltip="How the medication is administered"
                        readOnly={true}
                        className="cursor-pointer"
                        icon={{
                            right: <BringzzIcon
                                icon="IconChevronDown"
                                library="Custom"
                                className="h-5 w-5 p-1 text-midnight-blue rounded-full"
                                size="12"
                            />
                        }}
                        onClick={() => setApplicationFormDrawerOpened(true)}
                    />

                    <BringzzBottomDrawer
                        isOpen={applicationFormDrawerOpened}
                        close={() => setApplicationFormDrawerOpened(false)}
                        title='Select Application Form'
                    >
                        <div className='px-4 py-6'>
                            <BringzzRadioList
                                onChange={(newValue) => {
                                    setApplicationForm(newValue);
                                }}
                                state={state}
                                className="rounded-xl w-full text-center"
                            >
                                {medicamentForms.map((form) => (
                                    <BringzzRadio
                                        key={form}
                                        value={form}
                                        className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400"
                                    >
                                        <div>{form}</div>
                                    </BringzzRadio>
                                ))}
                            </BringzzRadioList>
                        </div>

                        <div className='text-center mb-12 px-4'>
                            <BringzzButton
                                className='bg-magic-lilac w-full flex justify-center'
                                onClick={() => setApplicationFormDrawerOpened(false)}
                            >
                                Confirm
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>

                    <div className="flex gap-4">
                        <div className="flex-1">
                            <BringzzInput
                                label="Dosage"
                                placeholder={dosage || "Select Dosage"}
                                tooltip="Medication dosage"
                                readOnly={true}
                                className="cursor-pointer"
                                icon={{
                                    right: <BringzzIcon
                                        icon="IconChevronDown"
                                        library="Custom"
                                        className="h-5 w-5 p-1 text-midnight-blue rounded-full"
                                        size="12"
                                    />
                                }}
                                onClick={() => setDosageDrawerOpened(true)}
                            />
                        </div>
                        <div className="flex-1">
                            <BringzzInput
                                label="Pack Size"
                                placeholder={packSize || "Select Pack Size"}
                                tooltip="Size of the medication package"
                                readOnly={true}
                                className="cursor-pointer"
                                icon={{
                                    right: <BringzzIcon
                                        icon="IconChevronDown"
                                        library="Custom"
                                        className="h-5 w-5 p-1 text-midnight-blue rounded-full"
                                        size="12"
                                    />
                                }}
                                onClick={() => setPackSizeDrawerOpened(true)}
                            />
                        </div>
                    </div>

                    <BringzzBottomDrawer
                        isOpen={dosageDrawerOpened}
                        close={() => setDosageDrawerOpened(false)}
                        title='Select Dosage'
                    >
                        <div className='px-4 py-6'>
                            <BringzzRadioList
                                onChange={(newValue) => {
                                    setDosage(newValue);
                                }}
                                state={state}
                                className="rounded-xl w-full text-center"
                            >
                                {dosageOptions.map((option) => (
                                    <BringzzRadio
                                        key={option}
                                        value={option}
                                        className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400"
                                    >
                                        <div>{option}</div>
                                    </BringzzRadio>
                                ))}
                            </BringzzRadioList>
                        </div>

                        <div className='text-center mb-12 px-4'>
                            <BringzzButton
                                className='bg-magic-lilac w-full flex justify-center'
                                onClick={() => setDosageDrawerOpened(false)}
                            >
                                Confirm
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>

                    <BringzzBottomDrawer
                        isOpen={packSizeDrawerOpened}
                        close={() => setPackSizeDrawerOpened(false)}
                        title='Select Pack Size'
                    >
                        <div className='px-4 py-6'>
                            <BringzzRadioList
                                onChange={(newValue) => {
                                    setPackSize(newValue);
                                }}
                                state={state}
                                className="rounded-xl w-full text-center"
                            >
                                {packSizeOptions.map((option) => (
                                    <BringzzRadio
                                        key={option}
                                        value={option}
                                        className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400"
                                    >
                                        <div>{option}</div>
                                    </BringzzRadio>
                                ))}
                            </BringzzRadioList>
                        </div>

                        <div className='text-center mb-12 px-4'>
                            <BringzzButton
                                className='bg-magic-lilac w-full flex justify-center'
                                onClick={() => setPackSizeDrawerOpened(false)}
                            >
                                Confirm
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>

                    <div className="relative">
                        <BringzzInput
                            label="Quantity"
                            tooltip="Number of packages needed"
                            value={opAmount.toString()}
                            readOnly
                            className="text-center"
                            icon={{
                                left: (
                                    <BringzzButton
                                        className="w-8 h-8 rounded-full flex items-center justify-center"
                                        onClick={() => setOpAmount(Math.max(1, opAmount - 1))}
                                    >
                                        -
                                    </BringzzButton>
                                ),
                                right: (
                                    <BringzzButton
                                        className="w-8 h-8 rounded-full flex items-center justify-center"
                                        onClick={() => setOpAmount(opAmount + 1)}
                                    >
                                        +
                                    </BringzzButton>
                                )
                            }}
                        />
                    </div>
                </div>
            </div>
        </BringzzPageContainer>
    );
};

export default PrescriptionFormProductsPage;